$(document).on('click', 'form#multiple_prescribers_confirmation button[type=submit]', function (event) {
  $('#multiple_prescribers_confirmation_modal').modal('hide');
});
